import { validateGeolocation } from 'js/hooks/auth/pas';
import { useCallback } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

import * as constants from '../constants';

export const useTriggerGeolocation = ({
    triggerTimestampRef,
    setTransactionID,
    setLicense,
    setNextTime,
    setShowOverlay,
    cancelRef,
    geolocationType,
    reasonRef
}) => {
    return useCallback(async ({ latitude = null, longitude = null, reason } = {}) => {
        if (cancelRef.current) {
            return;
        }

        // set the reason for Geolocation
        reasonRef.current = reason ?? constants.GEOLOCATION_REASON.UNDEFINED;

        publicEventsAPIService.trigger('geofencing-trigger', { reason: reasonRef.current });

        triggerTimestampRef.current = null;
        setTransactionID(null);
        setLicense(null);
        setNextTime(0);

        const response = await validateGeolocation(latitude, longitude, null, null, null, geolocationType);
        const sessionValidationData = response.data.sessionValidationData || {};

        if (!sessionValidationData.SessionValidationByGeolocationData) {
            // no geofencing -- go straight to end.
            return;
        }

        const sessionValidationByGeolocationData = sessionValidationData.SessionValidationByGeolocationData || [];
        const geolocationData = sessionValidationByGeolocationData[0] || {};
        const nextCheckIn = Number(geolocationData.nextCheckIn);

        if (nextCheckIn > 0) {
            // check will be done in some time, all good for now
            setShowOverlay(false);
        } else {
            setShowOverlay(true);
        }

        // ensure that nextTime is set before setting license and txId
        setNextTime(nextCheckIn);

        triggerTimestampRef.current = Date.now();
        setTransactionID(geolocationData.transactionId);
        setLicense(geolocationData.license);
    }, [
        setShowOverlay,
        triggerTimestampRef,
        setTransactionID,
        setLicense,
        setNextTime,
        cancelRef,
        geolocationType,
        reasonRef
    ]);
};
